import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-reload-data',
    template: '',
    styles: []
})
export class ReloadDataComponent implements OnInit {
    constructor(private location: Location) {}

    ngOnInit(): void {
        this.goBackToPrevPage();
    }
    goBackToPrevPage(): void {
        this.location.back();
    }
}
